import G6, { TreeGraph } from '@antv/g6/dist/g6.min';
import { directSubRuleOperationOptions } from '../options';
import { generateActionBar } from './common';
import {
  conditionContentPaddingY,
  conditionRowHeight,
  conditionRowInnerHeight,
  conditionTitleHeight,
  CustomNodeType,
  splitLineHeight,
  splitLineMargin,
  textareaHeight
} from './config';

export const registerSimpleConditionShape = (treeGraph: TreeGraph) => {
  G6.registerNode(CustomNodeType.SIMPLE_CONDITION, {
    draw: (cfg, group) => {
      const conditionHtml = `
      <div style="display: flex;align-items: center;column-gap: 4px;height: ${conditionRowHeight}px">
        <select disabled class="condition-select" style="height: ${conditionRowInnerHeight}px;" placeholder="类型">
        ${directSubRuleOperationOptions.reduce(
          (t, c) =>
            t +
            `<option value="${c.value}" ${
              c.value === cfg.jsonData.equityInformationRule.directDescentOption ? 'selected' : ''
            }>${c.label}</option>`,
          ''
        )}
        </select>
      </div>
    `;

      return group!.addShape('dom', {
        attrs: {
          width: cfg!.size![0],
          height: cfg!.size![1],
          // 传入 DOM 的 html
          html: `
          <div>
            <div style="background-color: #f2f2f2;border-radius:4px;height: 100%;">
              <div style="background-color: ${
                cfg!.style!.titleBgColor
              }; color: #fff; font-size: 12px;text-align: center;border-radius:4px;height: ${conditionTitleHeight}px;line-height: ${conditionTitleHeight}px;">
              ${cfg!.title}
              </div>
              <div style="padding: ${conditionContentPaddingY}px ${conditionContentPaddingY * 2}px;">
                <div style="display: flex;">
                  ${conditionHtml}
                </div>
                <div style="height: ${splitLineHeight}px;margin: ${splitLineMargin}px 0;background-color: ${
            cfg!.isPre ? '#d70a25' : 'var(--oio-button-primary-background)'
          };">
                </div>
                <textarea 
                  disabled
                  class="activity-textarea"
                  data-id="${cfg!.id}"
                  placeholder="" 
                  style="width: 100%;height: ${textareaHeight}px;border-radius: 4px;padding: 3px;resize: none;" 
                  rows="3">${cfg.effectConditionDesc || ''}</textarea>
              </div>
            </div>
            ${generateActionBar(cfg)}
          </div>
        `
        }
      });
    }
  });
};
